export const PUBLIC_AUTHOR_ROLES = ['A', 'CA', 'ED']

const ROLE_LABELS_FALLBACK = {
  A: 'Администратор',
  CA: 'Соадминистратор',
  ED: 'Редактор',
  CE: 'Редактор категорий',
}

export function userDisplayName(user) {
  if (!user) return ''
  return user.profile?.nickname ?? user.username ?? String(user.id ?? '')
}

export function userRoleLabel(role, rolesFromConsts) {
  if (rolesFromConsts && rolesFromConsts[role]) {
    return rolesFromConsts[role]
  }
  return ROLE_LABELS_FALLBACK[role] || role || ''
}

export function userAvatarUrl(user) {
  const id = user?.profile?.avatar
  if (!id) return null
  return `${process.env.BASE_URL_V2}/storage/d/avatars/${id}`
}

/** Единая логика: фото → иконка профиля → стоковая иконка */
export function getUserAvatarDisplay(user) {
  const avatarId = user?.profile?.avatar
  if (avatarId) {
    return { type: 'photo', url: userAvatarUrl(user), iconId: null }
  }
  const iconId = user?.profile?.icon
  if (iconId) {
    return { type: 'icon', url: null, iconId }
  }
  return { type: 'stock', url: null, iconId: null }
}

export function authorContributionTotal(row) {
  if (!row) return 0
  const encyclopedia = Number(row.encyclopedia_total) || 0
  const articles = Number(row.articles_total) || 0
  const sum = encyclopedia + articles
  if (sum > 0) {
    return sum
  }
  return Number(row.materials_total) || 0
}

export function formatAuthorContribution(total) {
  const n = Number(total) || 0
  return `Вклад: ${n} объектов и статей`
}

export function expertDisplayName(expert) {
  if (!expert) return ''
  if (expert.profileUser) {
    return userDisplayName(expert.profileUser)
  }
  return authorRowDisplayName(expert)
}

export function isPublicAuthor(user) {
  if (!user || user.is_enabled === false) return false
  return PUBLIC_AUTHOR_ROLES.includes(user.role)
}

export function authorRowDisplayName(row) {
  if (!row) return ''
  return row.author_nickname || row.author_username || String(row.author_id || '')
}

export function authorProfilePath(row) {
  const id = row?.author_id || row?.id
  if (!id) return null
  return { name: 'u-id', params: { id: String(id) } }
}
